import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import _regeneratorRuntime from "@babel/runtime/regenerator";
import { isTwoColumn } from '@outdoor-voices/ui/dist/utils/dom/isMobile';
import { useQuery } from 'urql';
import PropTypes from 'prop-types';
import React, { memo, useEffect, useRef, useState } from 'react';
import { RESIZE } from '../../config/constants';
import { OV_GRAPHQL_URL } from '../../config/theme';
import { productQuery, query } from './queries';
import css from './Recommendations.module.scss';
import CollectionLoading from '../CollectionLoading';
import ErrorBoundary from '../ErrorBoundary';
import ProductListItem from '../ProductListItem';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var maxTries = 5;

var load = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(variables) {
    var request, response;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _context.next = 3;
            return fetch(OV_GRAPHQL_URL, {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json'
              },
              body: JSON.stringify({
                query: query,
                variables: variables
              })
            });

          case 3:
            request = _context.sent;
            _context.next = 6;
            return request.json();

          case 6:
            response = _context.sent;
            return _context.abrupt("return", response.data);

          case 10:
            _context.prev = 10;
            _context.t0 = _context["catch"](0);
            console.error(_context.t0);
            return _context.abrupt("return", {});

          case 14:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[0, 10]]);
  }));

  return function load(_x) {
    return _ref.apply(this, arguments);
  };
}();

var ProductLoader = function ProductLoader(_ref2) {
  var shopifyId = _ref2.shopifyId,
      colorwayId = _ref2.colorwayId,
      token = _ref2.token;

  var _useState = useState(isTwoColumn()),
      _useState2 = _slicedToArray(_useState, 2),
      isMobile = _useState2[0],
      setIsMobile = _useState2[1];

  var _useQuery = useQuery({
    query: productQuery,
    variables: {
      shopifyId: shopifyId
    }
  }),
      _useQuery2 = _slicedToArray(_useQuery, 1),
      _useQuery2$ = _useQuery2[0],
      data = _useQuery2$.data,
      fetching = _useQuery2$.fetching;

  useEffect(function () {
    var onResize = function onResize() {
      var newIsMobile = isTwoColumn();

      if (newIsMobile === isMobile) {
        return;
      }

      setIsMobile(newIsMobile);
    };

    window.addEventListener(RESIZE, onResize);
    return function () {
      window.removeEventListener(RESIZE, onResize);
    };
  }, [isMobile]);

  if (fetching) {
    return /*#__PURE__*/_jsx("div", {
      "aria-busy": "true",
      className: css.loading
    });
  }

  var product = data.product;
  return /*#__PURE__*/_jsx(ProductListItem, {
    displaySwatches: true,
    displayWishListToggle: true,
    faceout: {
      id: btoa("ColorwayNode:".concat(colorwayId))
    },
    isMobile: isMobile,
    product: product,
    token: token
  });
};

ProductLoader.propTypes = {
  shopifyId: PropTypes.string.isRequired,
  colorwayId: PropTypes.number.isRequired,
  token: PropTypes.string.isRequired
};

var Loader = function Loader(_ref3) {
  var id = _ref3.id,
      title = _ref3.title,
      visitorId = _ref3.visitorId,
      variantIds = _ref3.variantIds;

  var _useState3 = useState(0),
      _useState4 = _slicedToArray(_useState3, 2),
      tries = _useState4[0],
      setTries = _useState4[1];

  var _useState5 = useState(false),
      _useState6 = _slicedToArray(_useState5, 2),
      data = _useState6[0],
      setData = _useState6[1];

  var fetchData = useRef(null);
  useEffect(function () {
    var timeout = null;
    fetchData.current = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      var _response$recommendat;

      var response;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return load({
                id: id,
                shopifyVariantIds: variantIds.join(','),
                visitorId: visitorId
              });

            case 2:
              response = _context2.sent;

              if ((response === null || response === void 0 ? void 0 : (_response$recommendat = response.recommendationsAi) === null || _response$recommendat === void 0 ? void 0 : _response$recommendat.status) === 'READY') {
                setData(response);
              } else {
                setTries(tries + 1);
              }

            case 4:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    if (!data && tries < maxTries) {
      timeout = setTimeout(function () {
        fetchData.current();
      }, 250);
    }

    return function () {
      clearTimeout(timeout);
    };
  }, [data, id, variantIds, visitorId, tries]);

  if (tries >= maxTries) {
    return false;
  }

  if (!data) {
    return /*#__PURE__*/_jsxs(_Fragment, {
      children: [title, /*#__PURE__*/_jsx(CollectionLoading, {
        fourUp: true
      })]
    });
  }

  var recommendationsAi = data.recommendationsAi;
  var recommendedProducts = recommendationsAi.recommendedProducts,
      recommendationToken = recommendationsAi.recommendationToken;

  if (recommendedProducts.length < 1) {
    return false;
  }

  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [title, data && /*#__PURE__*/_jsx("ul", {
      className: css.list,
      children: recommendedProducts.map(function (recommendedProduct) {
        return /*#__PURE__*/_jsx("li", {
          className: css.item,
          children: /*#__PURE__*/_jsx(ErrorBoundary, {
            children: /*#__PURE__*/_jsx(ProductLoader, _objectSpread(_objectSpread({}, recommendedProduct), {}, {
              token: recommendationToken
            }))
          })
        }, recommendedProduct.shopifyId);
      })
    })]
  });
};

Loader.propTypes = {
  id: PropTypes.string.isRequired,
  title: PropTypes.node.isRequired,
  visitorId: PropTypes.string.isRequired,
  variantIds: PropTypes.arrayOf(PropTypes.number).isRequired
};
export default /*#__PURE__*/memo(Loader);